function coffeeValidate(values) {
    let errors = {};

    if (!values.VarityID)
        errors.VarityID = 'VarityID is required';

    if (!values.TypeID)
        errors.TypeID = 'TypeID is required';

    if (!values.Price)
        errors.Price = 'Price is required';

    if (!values.Quantity)
        errors.Quantity = 'Quantity is required';

    if (!values.PaymentTypeID)
        errors.PaymentTypeID = 'PaymentTypeID is required';

    return errors;
};

export default coffeeValidate;
